<template>
  <div>
    <label class="label-style" v-if="title">
      {{title}}
      <span class="subTitleClass" v-if="subTitle">({{subTitle}})</span>
    </label>
    <b-form-textarea
      :name="lablelName"
      @keydown="inputText($event)"
      @keyup="inputText($event)"
      :id="lablelName"
      v-validate="validation"
      :state="errors.has(lablelName) ? false : null"
      :rows="rows"
      :value="defaultValue"
      :disabled="disabled"
      class="width-control-small lato-regular-input m-0 tabel-MultiLine-text"
    ></b-form-textarea>
    <div
      :class="'helo-block alert alert-danger errorWidthSmall mt-1'"
      v-show="errors.has(lablelName)"
    >{{errors.first(lablelName)}}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [
    "title",
    "defaultValue",
    "validation",
    "disabled",
    "lablelName",
    "subTitleClass",
    "subTitle",
    "maxTextLength"
  ],
  methods: {
    // inputText(event) {
    //   // console.log(event);
    //   this.$emit("inputChanges", event);
    // },
    inputText(event) {
      // console.log(event);
      if (
        event.target.value.length < parseInt(this.maxTextLength) ||
        event.keyCode == 46 ||
        event.keyCode == 8 ||
        event.keyCode == 37 ||
        event.keyCode == 39 ||
        event.keyCode == 9
      ) {
        this.$emit("inputChanges", event.target.value);
      } else {
        event.preventDefault();
      }
    }
  }
};
</script>
<style scoped>
.label-style {
  font-family: "Open Sans", sans-serif !important;
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  color: #272727;
}
.form-control:focus {
  box-shadow: none !important;
}
.sub-title-mandatory {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  color: #3e6a85;
}
.sub-title-optional {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  color: #7e7e7e;
}
.subTitleClass {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  font-style: italic;
}
</style>